import { lazy } from 'react'

import {
  ROUTE_PATH_LIST_SEARCH_RESULTS,
  ROUTE_UI_SECTION_NAME,
  SEARCH_RESULTS_REQUESTS_QUERY_PARAM_KEY,
  WEBAPP_SEARCH_ENTITY,
} from '../constants/route'
import {
  getPermissionGuardLoader,
  getSectionWebappRedirectGuardLoader,
} from '../utils/route'

const SearchResultsBuildings = lazy(() =>
  import('../components/SearchResults').then(m => ({
    default: m.SearchResultsBuildings,
  }))
)
const SearchResultsEmails = lazy(() =>
  import('../components/SearchResults').then(m => ({
    default: m.SearchResultsEmails,
  }))
)
const SearchResultsFlats = lazy(() =>
  import('../components/SearchResults').then(m => ({
    default: m.SearchResultsFlats,
  }))
)
const SearchResultsInhabitants = lazy(() =>
  import('../components/SearchResults').then(m => ({
    default: m.SearchResultsInhabitants,
  }))
)
const SearchResultsPosts = lazy(() =>
  import('../components/SearchResults').then(m => ({
    default: m.SearchResultsPosts,
  }))
)
const SearchResultsProviders = lazy(() =>
  import('../components/SearchResults').then(m => ({
    default: m.SearchResultsProviders,
  }))
)
const SearchResultsRequests = lazy(() =>
  import('../components/SearchResults').then(m => ({
    default: m.SearchResultsRequests,
  }))
)

export function getSearchResultsRoutes({ availableSections, sections }) {
  return [
    {
      element: <SearchResultsRequests />,
      loader: getSectionWebappRedirectGuardLoader({
        availableSections,
        searchParamKey: SEARCH_RESULTS_REQUESTS_QUERY_PARAM_KEY,
        sectionName: ROUTE_UI_SECTION_NAME.serviceRequestsSearch,
        sections,
        webappEntity: WEBAPP_SEARCH_ENTITY.serviceRequests,
      }),
      path: ROUTE_PATH_LIST_SEARCH_RESULTS.requests,
    },
    {
      element: <SearchResultsProviders />,
      loader: getPermissionGuardLoader({
        sectionName: ROUTE_UI_SECTION_NAME.providersSearch,
        sections,
      }),
      path: ROUTE_PATH_LIST_SEARCH_RESULTS.providers,
    },
    {
      element: <SearchResultsPosts />,
      loader: getSectionWebappRedirectGuardLoader({
        availableSections,
        searchParamKey: SEARCH_RESULTS_REQUESTS_QUERY_PARAM_KEY,
        sectionName: ROUTE_UI_SECTION_NAME.newsboardSearch,
        sections,
        webappEntity: WEBAPP_SEARCH_ENTITY.newsboard,
      }),
      path: ROUTE_PATH_LIST_SEARCH_RESULTS.posts,
    },
    {
      element: <SearchResultsBuildings />,
      loader: getSectionWebappRedirectGuardLoader({
        availableSections,
        sectionName: ROUTE_UI_SECTION_NAME.buildingsSearch,
        sections,
        webappEntity: WEBAPP_SEARCH_ENTITY.buildings,
      }),
      path: ROUTE_PATH_LIST_SEARCH_RESULTS.buildings,
    },
    {
      element: <SearchResultsEmails />,
      loader: getSectionWebappRedirectGuardLoader({
        availableSections,
        sectionName: ROUTE_UI_SECTION_NAME.mailsSearch,
        sections,
        webappEntity: WEBAPP_SEARCH_ENTITY.mails,
      }),
      path: ROUTE_PATH_LIST_SEARCH_RESULTS.emails,
    },
    {
      element: <SearchResultsFlats />,
      loader: getSectionWebappRedirectGuardLoader({
        availableSections,
        sectionName: ROUTE_UI_SECTION_NAME.flatsSearch,
        sections,
        webappEntity: WEBAPP_SEARCH_ENTITY.flats,
      }),
      path: ROUTE_PATH_LIST_SEARCH_RESULTS.flats,
    },
    {
      element: <SearchResultsInhabitants />,
      loader: getSectionWebappRedirectGuardLoader({
        availableSections,
        sectionName: ROUTE_UI_SECTION_NAME.inhabitantsSearch,
        sections,
        webappEntity: WEBAPP_SEARCH_ENTITY.inhabitants,
      }),
      path: ROUTE_PATH_LIST_SEARCH_RESULTS.inhabitants,
    },
  ]
}
